import * as Contract from '../../SharedApiExternalContract';

import { TableauError } from '../TableauError';
import { TableauWorksheetEvent } from './TableauWorksheetEvent';

export class FilterChangedEvent extends TableauWorksheetEvent implements Contract.FilterChangedEvent {
  public constructor(worksheet: Contract.Worksheet, private _fieldName: string) {
    super(Contract.TableauEventType.FilterChanged, worksheet);
  }

  public get fieldName(): string {
    return this._fieldName;
  }

  public getFilterAsync(): Promise<Contract.Filter> {
    return this._worksheet.getFiltersAsync().then<Contract.Filter>(filters => {
      // TODO: Filtering of the filters should eventually be done platform side.
      const eventedFilter = filters.find((filter) => (filter.fieldName === this._fieldName));

      if (!eventedFilter) {
        // We shouldn't hit this unless the filter was removed from the worksheet
        // after the event was raised.
        throw new TableauError(Contract.ErrorCodes.MissingFilter, `cannot find filter: ${this._fieldName}`);
      }

      return eventedFilter;
    });
  }
}



// WEBPACK FOOTER //
// ../../../../src/ApiShared/Events/FilterChangedEvent.ts


// WEBPACK FOOTER //
// webpack:///src/ApiShared/Events/FilterChangedEvent.ts